/**
 * WELCHE MITARBEITER-EINSTELLUNGEN EIN MANDANT ÜBERHAUPT HAT.
 *
 * Thomas 14.08.2026: „nur Einstellungen die auch genutzt werden dürfen vorhanden
 * sein bei geo. also kein Ü-50% Modus z.b. und bei zöscher dann ebenfalls anders
 * rum. reflektiere das am regelwerk."
 *
 * Bis dahin zeigte die Mitarbeiter-Tabelle ALLE Spalten für ALLE Mandanten:
 *  - „Soll-Zeiten Mo–Sa" + „Σ h/Woche" bei 3G, obwohl deren Regelwerk
 *    ausdrücklich sagt: *„3G rechnet Monatssummen — es gibt kein Soll/Ist und die
 *    Mitarbeiter haben by design KEINE Wochenarbeitszeit im System"*
 *    (`sollzeiten_required: false`, Karte 587). Gemessen: 0 von 94.
 *  - „Ü-50% Modus" (ZA-Konto / Cash / Pauschale) bei 3G, obwohl es dort kein
 *    ZA-Konto gibt — alle 94 standen auf dem Vorgabewert `za`, nie gepflegt.
 *  - Umgekehrt hätte die neue Spalte „Ü-Pauschale" (Karte 725) beim
 *    Bestandsmandanten nichts zu suchen: dort entscheidet der Ü-50%-Modus.
 *
 * Ein Einstellfeld, das nichts bewirkt, ist schlimmer als ein fehlendes: Es lädt
 * ein, etwas zu pflegen, das niemand liest — und beim nächsten Fehler sucht man
 * dort zuerst.
 *
 * Die Entscheidung fällt am REGELWERK, nicht am Mandanten-Namen (Bau-Regel P5:
 * kein `if (clientId === ...)`). Wer einen dritten Mandanten aufsetzt, bekommt
 * die richtigen Spalten, ohne diese Datei anzufassen.
 */

/** Das Summen-Modell (Zulagenblatt/Fahrtenbuch, Monatssummen je Art). */
export const SUMMEN_MODELL = "zulagen_summen_v0";

export interface MitarbeiterSpalten {
  /** Wochenarbeitszeit Mo–Sa + Wochensumme. */
  sollzeiten: boolean;
  /** Wie 50%-Überstunden ausbezahlt werden (ZA-Konto / Cash / Pauschale). */
  payMode: boolean;
  /** Überstundenpauschale laut Vertrag — ja/nein/nicht hinterlegt (Karte 725). */
  pauschale: boolean;
  weeklyThreshold: boolean;
}

/**
 * `ruleset` = die Sicht, die auch der Worker rechnet (api.clientRules).
 * `null` (noch nicht geladen) → der Bestandsstand, damit nichts flackert und
 * niemand aus einem Ladezustand eine Aussage ableitet.
 */
export function mitarbeiterSpalten(
  ruleset: { calc_model?: string | null; sollzeiten_required?: boolean } | null | undefined,
): MitarbeiterSpalten {
  const summenModell = ruleset?.calc_model === SUMMEN_MODELL;
  return {
    // Genau das Flag, das auch das Validate-Gate liest — EINE Wahrheit.
    // Fehlt es (Bestandsmandant ohne DB-Zeile), gilt der Code-Vorgabewert true.
    sollzeiten: ruleset?.sollzeiten_required !== false,
    // Der Ü-50%-Modus gehört zur Stundenlisten-Abrechnung mit ZA-Konto.
    payMode: !summenModell,
    // Die Pauschale entscheidet im Summen-Modell über Üst 50/100 (Karte 725).
    pauschale: summenModell,
    weeklyThreshold: !summenModell,
  };
}
